import { getUserAttributesFromToken } from 'utils/local-storage/attributes';

export async function getUserPermissionsAPI() {
  const attributes = await getUserAttributesFromToken();
  
  if (!attributes || !attributes['custom:data']) {
    return {};
  }

  try {
    const customData = JSON.parse(attributes['custom:data']);
    return customData.permissions || {};
  } catch (e) {
    return {};
  }
}

/**
 * Check if user has a specific permission
 * @param {Object} permissions - The permissions object
 * @param {string} resource - The resource key (e.g., 'admin-users', 'my-details')
 * @param {string} action - The action to check (e.g., 'read', 'write', 'update', 'delete', 'create', 'assign')
 * @returns {boolean}
 */
export function hasPermission(permissions, resource, action) {
  if (!permissions || !resource || !action) {
    return false;
  }

  return permissions[resource]?.[action] === true;
}
